module.exports = __webpack_public_path__ + "static/img/memberLAY.70ac10d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberLAY.png
// module id = pJVG
// module chunks = 0